// Copyright (c) 2024 - Present. Hardfin, Inc. All rights reserved.
// Hardfin Confidential - Restricted
import { uploadFile } from '@/file/api/upload-file';

/**
 * Uploads a file for a project to the remote API.
 *
 * @param id - The ID of the project for which to upload the file.
 * @param file - The file to upload.
 */
export async function uploadProjectFile(id: string, file: File) {
  return uploadFile(file, {
    context: 'PROJECT_FILE',
    isPublic: false,
    entityId: id,
  });
}
